import { render, staticRenderFns } from "./AgeInput.vue?vue&type=template&id=6326cd65&scoped=true"
import script from "./AgeInput.vue?vue&type=script&lang=ts"
export * from "./AgeInput.vue?vue&type=script&lang=ts"
import style0 from "./AgeInput.vue?vue&type=style&index=0&id=6326cd65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326cd65",
  null
  
)

export default component.exports